import { render } from "./AutoLogout.vue?vue&type=template&id=6dec7199&ts=true"
import script from "./AutoLogout.vue?vue&type=script&lang=ts"
export * from "./AutoLogout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__